import { useState } from "react";
import PropTypes from "prop-types";
import { Button, Dropdown } from "antd";
import { HiDotsHorizontal } from "react-icons/hi";

/**
 * The "⋯" actions menu used for table rows, cards and page headers. It opens on hover so users
 * don't have to click just to see what's available; a click (or Enter on the focused button) also
 * opens it but never toggles an already-open menu shut, and touch devices get it on tap.
 */
function RowActionsMenu({ items, onClick, label, disabled = false, icon, className, size = "small", loading }) {
    const [open, setOpen] = useState(false);

    return (
        <Dropdown
            trigger={["hover"]}
            open={open && !disabled}
            onOpenChange={setOpen}
            placement="bottomRight"
            disabled={disabled}
            mouseLeaveDelay={0.15}
            menu={{
                items,
                onClick: (info) => {
                    info.domEvent?.stopPropagation?.();
                    setOpen(false);
                    onClick(info);
                },
            }}>
            <Button
                type="text"
                size={size}
                icon={icon ?? <HiDotsHorizontal />}
                aria-label={label}
                aria-haspopup="menu"
                aria-expanded={open}
                aria-busy={loading}
                disabled={disabled}
                className={className}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOpen(true);
                }}
            />
        </Dropdown>
    );
}

RowActionsMenu.propTypes = {
    items: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.node,
    className: PropTypes.string,
    size: PropTypes.oneOf(["small", "middle", "large"]),
    loading: PropTypes.bool,
};

export default RowActionsMenu;
